import React, {memo} from "react";
import Label from "components/general/Label"
import useViewport from "components/general/useViewPort";
import { arraysEqual } from "helpers/utils";
import SportCode from "components/common/SportCode";

const TableExpanded = memo((props) => {
    const { breakPoint } = useViewport();
    const {row, officials} = props;
    const positions = officials.map(o => ({order: o?.order+'', position: o?.extensions?.find(e => e?.oe_code === 'JURY')?.oe_value}))?.sort((a, b) => a?.order -b?.order);
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    //console.log(row)

    const resultRowsXl = positions.map(pos => {
        const position = positions?.find(l => l?.order+'' === pos?.er_pos+'')?.letter;
        const res = row?.extendedResults?.find(er =>er?.er_code === 'D_JUDGE' && er?.er_pos === pos?.order )?.er_value;
        const irm = row.resultIrm ? <SportCode discipline='EQU' entity='@IRM' code={row.resultIrm} abbr={true} isAddLegend={false} /> : <></> 
        return (
            <tr key={pos?.order}>
                <td className="text-end fw-bold w-10">{pos?.position}</td>
                <td className="text-end w-10">{res}</td>
                <td className="text-end w-10">{pos?.order === '4' ? <>{row?.resultData} {irm}</> : '' }</td>
                <td className="w-70"></td>
            </tr>
        );
    })
    

    const xl = (
        <table className="w-80 table-borderless">
            <thead>
                <tr>
                    <td className="text-center fw-bold w-20" colSpan={2}><Label data='HeaderPercentScore' /></td>
                    <td className="text-end fw-bold w-10" ><Label data='HeaderTotal' /></td>
                    <td className="w-70"></td>
                </tr>
            </thead>
            <tbody>
                {resultRowsXl}
            </tbody>
        </table>
    );

    const resultRowsXs = positions.map(pos => {
        const res = row?.extendedResults?.find(er =>er?.er_code === 'D_JUDGE' && er?.er_pos === pos?.order )?.er_value;
        return (
            <tr key={pos?.order}>
                <td className="text-start fw-bold w-50 ps-5">{pos?.position}</td>
                <td className="text-end w-50 pe-5">{res}</td>
            </tr>
        );
    })

    const xs = (
        <table className="w-80 table-borderless">
            <thead>
                <tr>
                    <td className="text-center fw-bold w-100" colSpan={2}><Label data='HeaderPercentScore' /></td>
                </tr>
            </thead>
            <tbody>
                {resultRowsXs}
            </tbody>
        </table>
    );

    return <>{isMobile ? xs : xl}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.res?.extendedResults, nextProps?.res?.extendedResults);
});


export default TableExpanded;


    /*
    const resultRowsXl_ = row?.extendedResults?.sort((a,b) => a?.er_pos - b?.er_pos)?.map(er => {
        const position = positions?.find(l => l?.order+'' === er?.er_pos+'')?.letter;
        return (
            <tr key={er?.er_pos}>
                <td className="text-end fw-bold w-10">{position}</td>
                <td className="text-end w-10">{er?.er_value}</td>
                <td className="text-end w-10">{er?.er_pos === '4' ? row?.resultData : '' }</td>
                <td className="w-70"></td>
            </tr>
        );
    })
    */

    /*
    const resultRowsXs_ = row?.extendedResults?.sort((a,b) => a?.er_pos - b?.er_pos)?.map(er => {
        console.log(er?.er_pos+'')
        const letter = positions?.find(l => l?.order+'' === er?.er_pos+'')?.letter;
        return (
            <tr key={er?.er_pos}>
                <td className="text-start fw-bold w-50 ps-5">{letter}</td>
                <td className="text-end w-50 pe-5">{er?.er_value}</td>
            </tr>
        );
    })
    */
